import React from 'react';
import { Inbox } from 'lucide-react';
import { useAdminLeads } from '../hooks/useAdminLeads';
import { PageHeader, PageLoading } from '../components/account/PageHeader';
import { LeadsTable } from '../components/admin/LeadsTable';

export default function LeadsDashboard() {
  const { leads, error, pending, signOut } = useAdminLeads();

  if (pending) return <PageLoading label="Loading leads…" />;

  return (
    <div className="min-h-screen bg-sand-50" data-testid="leads-dashboard">
      <PageHeader widthClass="max-w-6xl" logoutTestId="dashboard-logout" onLogout={signOut} />
      <div className="max-w-6xl mx-auto px-5 py-10">
        <h1 className="font-serif text-3xl sm:text-4xl text-[#143160] mb-1">Leads Dashboard</h1>
        <p className="text-neutral-500 mb-8 flex items-center gap-2"><Inbox className="w-4 h-4" />{leads ? `${leads.length} leads` : ''}</p>
        {error && <p className="text-red-600">{error}</p>}
        {leads && <LeadsTable leads={leads} />}
      </div>
    </div>
  );
}
